import User from 'records/User';
import {Coordinate} from 'charts/types';
import {Data, Double} from '@store/@types/util';
import {Moment} from 'moment';

// TODO split this up and avoid circular deps

export enum Metric {
  AGGREGATED_SKILL = 'aggregated_skill',
  CALL_AVG_DURATION = 'avgduration',
  CALL_LISTENED_COUNT = 'listening_count',
  CALL_PLACED = 'conversations',
  CALL_SCORING = 'scoring',
  CALL_SCORING_SKILLS = 'scorecard_skills',
  CALL_SCORED = 'calls_scored',
  CALL_TOTAL_DURATION = 'totalduration',
  COACHING_PLAN_IMPROVEMENT = 'coaching_plan_improvement',
  COMMENTED = 'comments_count',
  ENGAGEMENT = 'engagement',
  INTERCHANGES = 'interchanges',
  KPI_OBSERVATION = 'kpi_observation',
  LIBRARY_ADDS = 'library_adds',
  TALK_LISTEN = 'talklisten',
  HIGHLIGHTED = 'highlights_count',

  // One Rep Chart?
  MEETING_TIME = 'meeting_time',
  REVIEW_TIME = 'review_time',
}

export enum MetricInfoGroup {
  SKILL = 'SKILL',
  ENGAGEMENT = 'ENGAGEMENT',
  KPI = 'KPI',
  SCORED_SKILLS = 'SCORED_SKILLS',
}

export interface MetricInfo {
  title: string;
  value: MetricParams;
  group: MetricInfoGroup;
}

export interface DataPoint {
  date: Moment;
  value: number;
}

export interface NullableDataPoint {
  date: Moment;
  value: number | null;
}

export enum MetricAxis {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

// TODO Fix case
export interface MetricFilter {
  // DATE_FORMAT = 'YYYY-MM-DD'
  startDate: string;
  // DATE_FORMAT = 'YYYY-MM-DD'
  endDate: string;
  teams?: string[];
}

export type MetricData = Record<string, {data: NullableDataPoint[]} | undefined>;

export type MetricResponse = {
  data: MetricData;
  metricAxis: MetricAxis;
};

export type MetricRange = {
  MIN: number;
  MAX: number;
};

export type MetricRangeLabel = {
  start: string;
  end: string;
};

export type AxesRanges = {
  xRange: MetricRange;
  yRange: MetricRange;
};

export type AxisMetricRangeLabel = {
  xRange: MetricRangeLabel;
  yRange: MetricRangeLabel;
};

export type RepMetricInfo = {
  xValueStr: string;
  yValueStr: string;
  bestSkill: string;
  worstSkill: string;
  coachingDuration: Double;
  hasPlan: boolean;
};

// TODO Redesign this interface to mesh better with the one rep variant
export type RepChartPoint = {
  rep: User;
  coordinate: Coordinate;
  metricInfo: RepMetricInfo;
};

export interface AxisState {
  metric: MetricParams;
  data: MetricData;
}

type MetricParamsInterface = {
  metric: Metric;
  direction?: 'any' | 'review' | 'coach';
  context?: string;
};

export class MetricParams extends Data<MetricParamsInterface>({
  context: undefined,
  direction: undefined,
  metric: undefined,
}) {}
